import type { AudioProfile } from "./audio-types";

/**
 * Ce qu'on demande à un micro, selon ce qu'il prend. Voir `AudioProfile`.
 *
 * Mono dans les deux cas : un micro de casque ou d'ordinateur n'a qu'une
 * capsule, et la stéréo coûterait du débit sans rien apporter.
 */
export const MICROPHONE_CAPTURE: Record<AudioProfile, MediaTrackConstraints> = {
  voice: { echoCancellation: true, noiseSuppression: true, autoGainControl: true, channelCount: 1 },
  instrument: { echoCancellation: false, noiseSuppression: false, autoGainControl: false, channelCount: 1 },
};

/**
 * Ouvre le micro de ce poste et rend sa piste. Le refus du navigateur remonte
 * tel quel : c'est à l'écran de le dire en mots.
 */
export async function openMicrophoneTrack(deviceId: string | null, profile: AudioProfile): Promise<MediaStreamTrack> {
  const constraints = MICROPHONE_CAPTURE[profile];
  const stream = await navigator.mediaDevices.getUserMedia({
    audio: deviceId === null ? constraints : { ...constraints, deviceId: { exact: deviceId } },
    video: false,
  });
  const track = stream.getAudioTracks()[0];

  if (track === undefined) {
    for (const other of stream.getTracks()) {
      other.stop();
    }

    throw new DOMException("Aucune piste audio.", "NotFoundError");
  }

  return track;
}
